<template>
  <form-block
    :title="tr('Source')"
    :description="tr('Please choose which Facebook or Instagram account you want to create ads from.')"
  >
    <p v-if="!entity.selectedBrand" class="m-0 text-muted-foreground">
      {{ tr('Please, select a brand.') }}
    </p>
    <info-text v-else-if="availableSources.length === 0" type="error">
      {{ tr('No data sources are available for the selected brand.') }}
    </info-text>
    <template v-else>
      <select-field
        v-model="entity.source_profiles[0]"
        :options="availableSources"
        label="name"
        :placeholder="tr('Select Social Profile')"
        :disabled="disabled"
      >
        <template #option="{ option }">
          <social-page :source-profile="getSourceProfile(option.id)" small />
        </template>
      </select-field>
      <asset-status-message :source-profile="entity.source_profiles[0]" />
    </template>
  </form-block>
</template>

<script>
import SourceProfile from '@/entities/SourceProfile.js';
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import BrandService from '@/services/Brand.js';
import SourceProfileService from '@/services/SourceProfile.js';
import AssetStatusMessage from '@/ui/components/AssetStatusMessage.vue';
import InfoText from '@/ui/components/InfoText.vue';
import SelectField from '@/ui/components/SelectField.vue';
import SocialPage from '@/ui/components/SocialPage.vue';

export default {
  name: 'SourceBlock',
  components: {
    AssetStatusMessage,
    InfoText,
    SelectField,
    SocialPage,
  },
  mixins: [ RuleFormBlockMixin ],
  computed: {
    availableSources() {
      return this.entity.selectedBrand?.sourceProfiles || [];
    },
  },
  watch: {
    'entity.brand.id': {
      immediate: true,
      handler(brandId, oldBrandId) {
        if (oldBrandId === undefined) {
          return;
        }
        if (!this.entity.isNew && !oldBrandId) {
          return;
        }
        if (!brandId) {
          return;
        }

        this.entity.source_profiles = [ new SourceProfile() ];
        this.applyRecommendedSourceProfile(brandId);
      },
    },
    'entity.isAppPromo'(val) {
      if (val) {
        this.entity.source_profiles = this.entity.source_profiles.filter(i => !i.platform || i.platform === 'instagram');
      }
    },
    'entity.source_profiles.0.id'() {
      this.generatePostAiScores();
    },
  },
  methods: {
    getSourceProfile(id) {
      return this.entity.selectedBrand?.sourceProfiles.find(s => s.id === id);
    },
    applyRecommendedSourceProfile(brandId) {
      if (!brandId) {
        return;
      }

      BrandService.getRecommendedSourceProfile(brandId)
        .then(recommended => {
          if (!recommended || !recommended.id) {
            return;
          }

          const matchedSourceProfile = this.getSourceProfile(recommended.id);
          if (matchedSourceProfile) {
            this.entity.source_profiles = [ matchedSourceProfile ];
          }

          return;
        })
        .catch(err => this.error(err));
    },
    generatePostAiScores() {
      const sourceProfile = this.entity.source_profiles[0];
      if (!sourceProfile || !sourceProfile.id) {
        return;
      }

      SourceProfileService.generatePostAiScores(sourceProfile.id);
    },
    validate() {
      if (this.entity.source_profiles.length > 1) {
        let hasValidSource = false;
        let hasInvalidSource = false;
        for (const item of this.entity.source_profiles) {
          if (item.id) {
            hasValidSource = true;
          }
          else {
            hasInvalidSource = true;
          }
        }

        if (hasValidSource && hasInvalidSource) {
          this.entity.source_profiles = this.entity.source_profiles.filter(item => item.id);
        }
      }

      for (const item of this.entity.source_profiles) {
        if (!item.id) {
          this.error(this.tr('At least one source must be selected for each platform!'));
          return false;
        }
      }

      return true;
    },
  },
};
</script>
